import PaymentDocuments from './PaymentDocuments';

export default PaymentDocuments;
